export default "__VITE_ASSET__CJv43YKA__"